import Components from "slotworks/components/components";
import AbstractSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/abstract-symbol-behaviour";

export default class StickSymbolBehaviour extends AbstractSymbolBehaviour {

    public behaviourName: string = "Stick";

    public stick() {
        Components.matrix.addStuckSymbol(this.symbol);
    }
}
